import type { AppointmentPreviewField } from './types';

export const DEFAULT_START_TIME = '08:00';
export const DEFAULT_END_TIME = '20:00';
export const DEFAULT_STEP_MINUTES = 30;
export const BOOKING_STEP_MINUTES = 15;
export const DEFAULT_GRID_STEP_MINUTES = 30;
export const CALENDAR_GRID_STEP_MINUTES_VALUES = [
  10, 15, 20, 30, 40, 60,
] as const;
export const TIMELINE_SLOT_HEIGHT = 60;
export const BOOKING_SLOT_HEIGHT = 30;
export const PIXELS_PER_MINUTE = 2;
export const HEADER_HEIGHT = 56;
export const DEFAULT_MAX_VISIBLE_COLUMN_COUNT = 8;
export const MIN_SELECTABLE_VISIBLE_COLUMN_COUNT = 4;
export const MAX_SELECTABLE_VISIBLE_COLUMN_COUNT = 10;

export const DEFAULT_CALENDAR_INTERVAL_HEIGHT_SIZE = 'small';
export const CALENDAR_INTERVAL_HEIGHT_BY_SIZE = {
  small: 16,
  medium: 20,
  large: 24,
} as const;

// Rows of the appointment preview in the journal grid. The default order is the
// one the preview had before it became configurable.
export const APPOINTMENT_PREVIEW_FIELD_KEYS = [
  'services',
  'phone',
  'client',
  'tags',
  'comment',
] as const;

export const APPOINTMENT_PREVIEW_FIELD_LABELS = {
  services: 'Услуги',
  phone: 'Телефон',
  client: 'ФИО клиента',
  tags: 'Теги',
  comment: 'Комментарий',
} as const;

export const DEFAULT_APPOINTMENT_PREVIEW_FIELDS: readonly AppointmentPreviewField[] =
  APPOINTMENT_PREVIEW_FIELD_KEYS.map((key) => ({ key, isVisible: true }));
